import React, { Component } from "react";

export class CustomCard extends Component {
  render() {
    const styles = () => {
      if (this.props.styles === undefined) return "header-no-background";
      if (this.props.styles.backgroundColor === "#1f2f6e") return null;
      return "header-no-background";
    }
  
    return (
      <div style={{backgroundColor:"rgba(255,255,255,0.7)", border: "1px solid #ccc",  boxShadow: "2px 2px 5px #ccc", height:this.props.height}} className={"card" + (this.props.plain ? " card-plain" : "")}>
        <div className={"header " + styles() + (this.props.hCenter ? " text-center" : "")} style={this.props.styles}>
          <h4 className="title" style={{color:this.props.color}}>{this.props.title}</h4>
          <p className="category">{this.props.category}</p>
        </div>
        <div
          className={
            "content" +
            (this.props.ctAllIcons ? " all-icons" : "") +
            (this.props.ctTableFullWidth ? " table-full-width" : "") +
            (this.props.ctTableResponsive ? " table-responsive" : "") +
            (this.props.ctTableUpgrade ? " table-upgrade" : "")
          }
        >
          {this.props.content}

          <div className="footer">
            {this.props.legend}
            {this.props.stats != null ? <hr /> : ""}
            <div className="stats">
              <i className={this.props.statsIcon} /> {this.props.stats}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomCard;



// WEBPACK FOOTER //
// ./src/components/Card/CustomCard.jsx